import { configureStore } from "@reduxjs/toolkit";
import { drawerMenu } from "./drawerMenu";
import { quotationSlice } from "../app/quotationApp/store";
import { searchRezSlice } from "../app/searchApp/store";
import { reservationSlice } from "./reservation";
import { loaderSlice } from "./loader";
import { agreementSlice } from "./agreement/agreementSlice";
import { additionalDriverSlice } from "../app/quotationApp/AdditionalDriverApp/store";
import { localServiceSlice } from "./localService/localServiceSlice";

export const store = configureStore({
    reducer: {
        drawerMenu: drawerMenu.reducer,
        quotation: quotationSlice.reducer,
        searchRez: searchRezSlice.reducer,
        reservation: reservationSlice.reducer,
        loader: loaderSlice.reducer,
        agreement: agreementSlice.reducer,
        additionalDriver: additionalDriverSlice.reducer,
        localService: localServiceSlice.reducer,
    }
})
